import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const FontSizeUpGlyph = /*#__PURE__*/createElement("g", {
  id: "font_size_up",
  transform: "scale(2.5)"
}, /*#__PURE__*/createElement("path", {
  d: "M12.5354 17.64L14.6954 24H17.4854L10.5854 3.78H7.43543L0.56543 24H3.26543L5.36543 17.64H12.5354ZM5.90543 15.6L7.88543 9.75C8.27543 8.52 8.60543 7.29 8.90543 6.09H8.96543C9.26543 7.26 9.56543 8.46 10.0154 9.78L11.9954 15.6H5.90543Z"
}), /*#__PURE__*/createElement("path", {
  d: "M23.8186 4.52324C24.0083 4.52324 24.06 4.4198 23.9221 4.28188L20.2845 0.609776C20.1465 0.471857 19.9397 0.471857 19.8017 0.609776L16.0779 4.28188C15.94 4.4198 15.9917 4.52324 16.1814 4.52324L23.8186 4.52324Z"
}));
const FontSizeUp = createSvg({
  name: 'fontSizeUp',
  path: FontSizeUpGlyph
});

export default FontSizeUp;
export { FontSizeUpGlyph };
